import dayjs from 'dayjs'

export function dateAndTime(v: string | null): string {
  return dayjs(v).format('Do MMM YYYY HH:mm')
}
